import { useTranslate } from "ra-core";
import { CreateButton } from "@/components/admin/create-button";
import { FilterButton } from "@/components/admin/filter-form";
import { DataTable } from "@/components/admin/data-table";
import { List } from "@/components/admin/list";
import { ListPagination } from "@/components/admin/list-pagination";

import { InitialDisplayedFilters } from "../filters/InitialDisplayedFilters";
import { KnownFiltersOnly } from "../filters/KnownFiltersOnly";
import { TopToolbar } from "../layout/TopToolbar";
import type { Partner } from "../types";
import { PartnerKind } from "./PartnerKind";
import { DEFAULT_PARTNER_FILTERS, usePartnerFilters } from "./partnerFilters";

/** « Partenaires » page: staff and partner businesses, laid out like the contacts. */
export const PartnerList = () => {
  const translate = useTranslate();
  const filters = usePartnerFilters();
  return (
    <List
      title={translate("resources.partners.name", { smart_count: 2 })}
      perPage={25}
      sort={{ field: "name", order: "ASC" }}
      filters={filters}
      actions={<PartnerListActions />}
      pagination={<ListPagination rowsPerPageOptions={[10, 25, 50, 100]} />}
      exporter={false}
    >
      <KnownFiltersOnly filters={filters} />
      <InitialDisplayedFilters sources={DEFAULT_PARTNER_FILTERS} />
      <PartnerTable />
    </List>
  );
};

const PartnerListActions = () => (
  <TopToolbar>
    <FilterButton />
    <CreateButton label="resources.partners.action.new" />
  </TopToolbar>
);

const PartnerTable = () => (
  <DataTable<Partner> rowClick="show" bulkActionButtons={false}>
    <DataTable.Col
      source="name"
      render={(record) => <span className="font-medium">{record.name}</span>}
    />
    <DataTable.Col
      source="category"
      render={(record) => <PartnerKind partner={record as Partner} />}
    />
    <DataTable.Col source="organisation" />
    <DataTable.Col source="phone" disableSort />
    <DataTable.Col source="email" disableSort />
  </DataTable>
);
